"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var isEmptyValue_1 = __importDefault(require("../helpers/isEmptyValue"));
var isRequired = function (value) { return (isEmptyValue_1.default(value) ? 'Required.' : undefined); };
exports.default = withCustomError_1.default(isRequired);
//# sourceMappingURL=isRequired.js.map